<!--
<doc lang="markdown">
</doc>


<style scoped lang="scss">
</style>


<template lang="pug">
</template>
-->

<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import EmailField from '../desktop/email-field.vue'
  export default EmailField
</script>
